export const GET_PRIVATE_MESSAGE = "GET_PRIVATE_MESSAGE"
export const GET_PRIVATE_MESSAGE_SUCCESS = "GET_PRIVATE_MESSAGE_SUCCESS"
export const GET_PRIVATE_MESSAGE_FAILED = "GET_PRIVATE_MESSAGE_FAILED"

export const UPDATE_PRIVATE_MESSAGE = "UPDATE_PRIVATE_MESSAGE"
export const UPDATE_PRIVATE_MESSAGE_SUCCESS = "UPDATE_PRIVATE_MESSAGE_SUCCESS"
export const UPDATE_PRIVATE_MESSAGE_FAILED = "UPDATE_PRIVATE_MESSAGE_FAILED"
export const RESET_PRIVATE_MESSAGE = "RESET_PRIVATE_MESSAGE"
